import React, { Component } from 'react';
import { Link } from 'react-router';

export default class LinkButton extends Component {

  render(){
    return (
      <Link
        onClick={this._handleClick}
        className={"btn " + this.props.classes}
        to={this.props.to}>{this.props.text} </Link>
    );
  }

  _handleClick (e) {
    if (this.props.clickButton) {
      this.props.clickButton(e, this); 
    } 
  }
}





// WEBPACK FOOTER //
// ./src/components/Buttons/linkButton.js